import $ from "jquery";
import Swiper from "swiper";
import { Navigation, Thumbs, A11y, Keyboard } from "swiper/modules";

export const init = function () {
  let homeThumbnails = new Swiper(".swiper-home-thumbnails", {
    slidesPerView: 1,
    centeredSlides: true,
    centeredSlidesBounds: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
  });

  let homeSlider = new Swiper(".swiper-home-slider", {
    modules: [Navigation, Thumbs, A11y, Keyboard],
    initialSlide: 1,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: ".swiper-home-slider-next",
      prevEl: ".swiper-home-slider-prev",
    },
    thumbs: {
      swiper: homeThumbnails,
    },
    a11y: {
      enabled: true,
    },
    on: {
      beforeInit: function () {
        $(".swiper-home-thumbnails .swiper-slide").each(function () {
          let $this = $(this);
          let param = $this.find("a").attr("href");
          $this.find("a").attr("data-href", param);
        });
        $(".ctype-ce_home_slider .blur-img").fadeOut();
      },
      afterInit: function () {
        $(".ctype-ce_home_slider").addClass("slider-init");
        homeThumbnails.slideTo(1, 0);
      },
      transitionStart: function (swiper) {
        homeThumbnails.slideTo(swiper.activeIndex, 200);
      },
      transitionEnd: function (swiper) {
        $(".swiper-home-thumbnails .swiper-slide a").attr(
          "href",
          "javascript:void(0);"
        );
        let href = $(
          ".swiper-home-thumbnails .swiper-slide-thumb-active a"
        ).attr("data-href");
        $(".swiper-home-thumbnails .swiper-slide-thumb-active a").attr(
          "href",
          href
        );
      },
    },
  });

  homeThumbnails.on("transitionEnd", function (swiper) {
    if (swiper.activeIndex !== homeSlider.activeIndex) {
      homeSlider.slideTo(swiper.activeIndex, 200);
    }
  });
};
